import { SfLog } from '@app/adapters/logger'

class PDFTronAnnotationsUtils {
  constructor(manager) {
    this.manager = manager
    this.instance = manager.instance
  }

  colorFromRGB(rgbArray) {
    return new this.instance.Core.Annotations.Color(...rgbArray)
  }

  handleError(error, extraPayload) {
    SfLog.error('PDFTronAnnotationsUtils error', {
      error,
      extra: {
        ownerId: this.manager.ownerId,
        ownerType: this.manager.ownerType,
        ...extraPayload,
      },
    })
  }
}

export default PDFTronAnnotationsUtils
